import { Field, ID, Int, ObjectType } from 'type-graphql'

@ObjectType()
export class Timezone {
  @Field(() => ID)
  _id: string

  @Field(() => ID)
  countryCode: string

  @Field(() => String)
  countryName: string

  @Field(() => String)
  zoneName: string

  @Field(() => Int)
  utcOffset: number

  @Field(() => Int)
  timestamp: number
}
